import { Flex, Radio } from "@mantine/core";

import { useFeedbackDraftStore } from "../../store";

interface FeedbackRadioGroupProps {
    categories: readonly string[];
    direction: "row" | "column";
}

export function FeedbackRadioGroup({ categories, direction }: FeedbackRadioGroupProps) {
    const category = useFeedbackDraftStore((state) => state.draft.category);

    const onChangeRadio = (value: string) => {
        const { draft, setDraft } = useFeedbackDraftStore.getState();
        setDraft({
            ...draft,
            category: value,
        });
    };

    return (
        <Radio.Group value={category} onChange={onChangeRadio}>
            <Flex direction={direction} gap="lg">
                {categories.map((label) => (
                    <Radio
                        size="sm"
                        key={label}
                        value={label}
                        label={label}
                        data-testid={`radio-feedback-${label}`}
                        fw={label === category ? 700 : 400}
                    />
                ))}
            </Flex>
        </Radio.Group>
    );
}
